// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1OtVy","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2XGaR"};